export function roller(ctx) {
    return {
        styles: {
            main:     { ...ctx.pretty, radius: 8, text_font: 32 },
            selected: { bg_color: ctx.primary, text_color: '#ffffff' },
        },
    };
}
